/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Install_Toast_BodyInputs */



/**
* | output |
* | --- |
* | "Open it from your home screen any time." |
*
* @param {Install_Toast_BodyInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const install_toast_body = /** @type {((inputs?: Install_Toast_BodyInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Install_Toast_BodyInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Öffne es jederzeit von deinem Home-Bildschirm.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ouvrez-le depuis votre écran d'accueil quand vous voulez.")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("随时从主屏幕打开它。")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("隨時從主畫面開啟它。")
	if (locale === "ko") return /** @type {LocalizedString} */ ("언제든 홈 화면에서 열 수 있어요.")
	return /** @type {LocalizedString} */ ("Open it from your home screen any time.")
});